import {Injectable} from '@angular/core';
import {Headers, Http} from '@angular/http';

import 'rxjs/add/operator/toPromise';
import {Observable} from 'rxjs/Rx';
import myGlobals = require('../config');

@Injectable()
export class InformeService {

    private informeUrl = myGlobals.default.BASE_URL + '/informe/';  // URL to web api

    constructor(private http: Http) {
    }

    // Informe mensual
    public getInformeMantenimiento(idSucursal, reporte: any, filename: string): Observable<any> {
        let headers = new Headers({
            'Content-Type': 'application/json;charset=UTF-8',
            'Accept': 'application/pdf'
        });
        headers.append('dataType', 'json');
        var sucursalStr = JSON.stringify(reporte);
        let requestOptions = {headers: headers, responseType: 'arraybuffer'};
        return this.http
            .post(this.informeUrl + idSucursal, sucursalStr, requestOptions)
            .map((response) => {
                const linkSource = `data:application/pdf;base64,${response.text()}`;
                const downloadLink = document.createElement("a");
                const fileName = "reporteMantenimientoBemakoha-" + filename + '-' + reporte.mes + reporte.anio + ".pdf";
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            });
    }

    // Informe resumen
    public getInformeResumen(idSucursal, reporte: any): Observable<any> {
        let headers = new Headers({
            'Content-Type': 'application/json;charset=UTF-8',
            'Accept': 'application/pdf'
        });
        headers.append('dataType', 'json');
        var sucursalStr = JSON.stringify(reporte);
        let requestOptions = {headers: headers, responseType: 'arraybuffer'};
        return this.http
            .post(this.informeUrl + "/informeResumen/" + idSucursal, sucursalStr, requestOptions)
            .map((response) => {
                //let reporteBlob = new Blob(["data:application/pdf;base64, " +response.text()], {type: 'data:application/pdf'});
                const linkSource = `data:application/pdf;base64,${response.text()}`;
                const downloadLink = document.createElement("a");
                const fileName = "reporteResumenBemakoha" + ".pdf";
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            });
    }

    public getInformeGeneral(idSucursal, reporte: any): Observable<any> {
        let headers = new Headers({
            'Content-Type': 'application/json;charset=UTF-8',
            'Accept': 'application/pdf'
        });
        headers.append('dataType', 'json');
        var sucursalStr = JSON.stringify(reporte);
        let requestOptions = {headers: headers, responseType: 'arraybuffer'};
        return this.http
            .post(this.informeUrl + "informeGeneral", sucursalStr, requestOptions)
            .map((response) => {
                const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${response.text()}`;
                const downloadLink = document.createElement("a");
                const fileName = "reporteGeneralBemakoha" + ".xlsx";
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            });
    }

    public getConfiguracionSucursal(idSucursal): Observable<any> {
        let headers = new Headers({
            'Content-Type': 'application/json;charset=UTF-8',
            'Accept': 'application/pdf'
        });
        headers.append('dataType', 'json');
        var sucursalStr = {sucursal_id: idSucursal};
        let requestOptions = {headers: headers, responseType: 'arraybuffer'};
        return this.http
            .post(this.informeUrl + "configuracionSucursal", sucursalStr, requestOptions)
            .map((response) => {
                const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${response.text()}`;
                const downloadLink = document.createElement("a");
                const fileName = "configuracionSucursal" + ".xlsx";
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            });
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/informes/informe.service.ts